// extracted by mini-css-extract-plugin
module.exports = {"noOffersCopy":"I7lrm6yQFnpBr_HbnoGw3"};